module.exports = __webpack_public_path__ + "static/media/terrace-3.1b2ab5c1.jpg";